<template>
  <div class="top-card-display__single-card top-card-display__single-card--usage">
    <div v-if="currentAccount">
      <div v-if="loadState === 'complete'" class="top-banner-card gds-card gds-data-card top-banner-card--logged-in">
        <div>
          <p class="gds-display-0 gds-space-stack-s">Usage This Billing Period</p>
          <p class="gds-card__caption">
            {{daysLeft}}
            <span v-if="daysLeft !== 1">days</span>
            <span v-if="daysLeft === 1">day</span>
            left
          </p>
        </div>

        <figure v-if="currentUsage !== undefined" class="gds-align--block-center">
          <div @click="navUsage()" class="card__usage--kw-wrap gds-flex-container gds-clickable">
            <div class="card__usage--kw-number">{{currentUsage | numberComma }}</div>
            <div class="card__usage--kwh">kWh</div>
          </div>
          <img src="/wp-content/themes/gmptwentynineteen/assets/images/electric-plug.svg" alt="electric plug" class="gds-align--block-center" />
        </figure>
        <div v-if="lastUsage !== undefined" class="card__usage--details">
          Last billing period you used a total of
          <span @click="navUsage()" class="gds-font-demi gds-clickable">{{lastUsage | numberComma}} kWh</span>.
        </div>
      </div>
      <div v-if="loadState !== 'complete'" class="top-banner-card gds-card gds-data-card top-banner-card--logged-in" :class="{'gds-loading': loadState === undefined }">
        <div>
          <p class="gds-display-0 gds-space-stack-s">Usage This Billing Period</p>
        </div>
        <div v-if="loadState === 'error'" class="card-error">
          Unable to load,
          <br />please try again later.
        </div>
        <div v-if="loadState === 'error'" class="card-error-layout-blank">&nbsp;</div>
        <!-- If we have an "expected" error (acct disconnected) show it instead of unable to load -->
        <div v-if="loadState === 'unavailable'" class="card-error">Usage information is not available for this account.</div>
        <div v-if="loadState === 'unavailable'" class="card-error-layout-blank">&nbsp;</div>
      </div>
    </div>
  </div>
</template>

<script>
import GMPAPI from "../../../services/gmpapi";
import { ToServerDateTruncate, ParseDateOnly, DumpError } from "../../../utilities";
import { parse, differenceInCalendarDays } from 'date-fns';

export default {
  name: "CardUsage",
  data() {
    return {
      currentUsage: undefined,
      lastUsage: undefined,
      daysLeft: undefined,

      loadState: undefined,
    };
  },
  computed: {
    currentAccount() {
      return this.$store.state.user.currentAccount;
    },
  },
  async mounted() {
    this.RefreshData();
  },
  methods: {
    async RefreshData() {
      this.currentUsage = undefined;
      this.lastUsage = undefined;
      this.daysLeft = undefined;
      this.loadState = undefined;
      if (!this.currentAccount) {
        this.loadState = "error";
        return;
      }
      try {
        const periods = await GMPAPI.GetBillingPeriods(this.currentAccount.accountNumber);
        const current = periods.periods.find(item => item.current);
        // If no current billing period, we can stop already
        if (current) {
          const last = periods.periods.find(item => item.last);
          const endDate = ParseDateOnly(current.endDate);
          this.daysLeft = differenceInCalendarDays(endDate, new Date());
          // Always pull the current period's data
          const waiters = [GMPAPI.GetPeriodUsage(this.currentAccount.accountNumber, "daily", ToServerDateTruncate(current.startDate), ToServerDateTruncate(current.endDate))];
          if (last) {
            // If there is a last period, pull the data for it
            waiters.push(GMPAPI.GetPeriodUsage(this.currentAccount.accountNumber, "daily", ToServerDateTruncate(last.startDate), ToServerDateTruncate(last.endDate)));
          }
          const [currentUsageData, lastUsageData] = await Promise.all(waiters);
          this.currentUsage = this.reduceUsage(currentUsageData);
          if (lastUsageData) {
            this.lastUsage = this.reduceUsage(lastUsageData);
          }
          this.loadState = "complete"
        } else {
          // No current period, so mark as disconnected
          this.loadState = "unavailable";
        }
      } catch (err) {
        // Check if the error was thrown because of a disabled account
        if (err && err.response && err.response.data && err.response.data.errorCode === "MDM_NO_ACTIVE_SERVICES") {
          this.loadState = "unavailable";
        } else {
          DumpError("Usage card refresh error", err);
          this.loadState = "error";
        }
      }
    },
    reduceUsage(usageData) {
      let totalUsage = 0;
      for (const interval of usageData.intervals) {
        for (const item of interval.values) {
          totalUsage += item.consumedTotal;
        }
      }
      return totalUsage;
    },
    navUsage() {
      this.$router.push({ path: "/usage" });
    },
  },
  watch: {
    // Recompute usage whenever the account changes
    currentAccount(newValue, oldValue) {
      this.RefreshData();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>